import { Component, Input, OnInit } from '@angular/core';
import { DataGrapModel } from '../model/dataGrapModel';
import { Chart } from 'angular-highcharts';

import * as Highcharts from 'highcharts';
import { DataGaussModel } from '../model/dataGaussModel';
declare var require: any
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/annotations')(Highcharts);
@Component({
  selector: 'app-lfsa-gh-campana-gauss',
  templateUrl: './lfsa-gh-campana-gauss.component.html',
  styleUrls: ['./lfsa-gh-campana-gauss.component.css']
})
export class LfsaGhCampanaGaussComponent implements OnInit {

  //@Input() dataLabel: [];
  @Input() dataList: DataGaussModel[];
  @Input() loading: boolean = false;
  @Input() idComponent: string;
  @Input() title: string;
  @Input() pesoReferencial?: any;
  @Input() minimo?: any;
  @Input() maximo?: any;
  //@Input() unidad: string;
  //@Input() colors: any[] = [];
  
  constructor() {}

  chart: Chart;
  minAxis;
  maxAxis;

  ngOnInit() {
    this.init();
  }
  
  init() {
    console.log(this.pesoReferencial);
    console.log('Minimo:'+this.min(this.dataList[0].data));
    console.log('Maximo'+this.max(this.dataList[0].data));
    this.pesoReferencial= this.pesoReferencial !== undefined ? this.pesoReferencial : 0.0;
    this.maximo= this.maximo !== undefined ? this.maximo : 0.01;
    this.minimo= this.minimo !== undefined ? this.minimo : 0.01;
    console.log(this.fun(this.dataList[0].data)[0]);
    this.minAxis = this.pesoReferencial != 0.0 ? (this.pesoReferencial*(1-this.minimo))*0.999 : (this.fun(this.dataList[0].data)[0])*(1-this.minimo);
    this.maxAxis = this.pesoReferencial != 0.0 ? (this.pesoReferencial*(1+this.maximo))*1.001 : (this.fun(this.dataList[0].data)[0])*(1+this.maximo);
    if(this.min(this.dataList[0].data)<this.minAxis )
      this.minAxis = this.min(this.dataList[0].data)*(1-this.minimo);
    if(this.max(this.dataList[0].data)>this.maxAxis)
      this.maxAxis = this.max(this.dataList[0].data)*(1+this.maximo);
    let objSetting:any ={
      chart: {
        type: 'areaspline'
      },
      title: {
        text: this.title//'Historic World Population by Region'
      },
      /*subtitle: {
        text: this.title//'Source: <a href="https://en.wikipedia.org/wiki/World_population">Wikipedia.org</a>'
      },*/
      xAxis: {
        min:this.minAxis,
        max:this.maxAxis,
        //tickPixelInterval: 60,
        plotLines: [{
                    color: '#008000', // green
                    width: 2,
                    value: this.fun(this.dataList[0].data)[0],
                    label: {
                      formatter: function () {
                          return 'Promedio: ' + this.options.value;
                      },
                      style: {
                        color: 'green',
                        fontWeight: 'bold'
                    }
                  }
                  },{
                    color: '#051eff', // blue
                    width: 2,
                    value: (this.pesoReferencial*(1+this.maximo)),
                    label: {
                      formatter: function () {
                          return 'Máximo: ' + this.options.value;
                      },
                      style: {
                        color: 'blue',
                        fontWeight: 'bold'
                    }
                  }
                  },{
                    color: '#FF0000', // red
                    width: 2,
                    value: (this.pesoReferencial*(1-this.minimo)),
                    label: {
                      formatter: function () {
                          return 'Mínimo: ' + this.options.value;
                      },
                      style: {
                        color: 'red',
                        fontWeight: 'bold'
                    }
                  }
                },{
                  color: 'black', //yellow 
                  width: 2,
                  value: (this.pesoReferencial),
                  label: {
                    verticalAlign: 'bottom',
                    textAlign: 'right',
                    formatter: function () {
                        return 'Peso Ref. : ' + Math.trunc(this.options.value);
                    },
                    style: {
                      color: 'black',
                      fontWeight: 'bold'
                  }
                }
              }],
      title: {
        text: 'Peso Balanza',
      }
      },
      yAxis: {
        title: {
          text: 'Distribución',
        },
        labels: {
          overflow: 'justify'
        }
      },
      tooltip: {
        shared: true,
        headerFormat: '<b>Peso de empaque {point.x}</b><br>'
      },
      plotOptions: {
        areaspline: {
          fillOpacity: 0.5
      }
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        verticalAlign: 'top',
        x: 120,
        y: 70,
        floating: true,
        borderWidth: 1,
        backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF'
    },
      credits: {
        enabled: false
      },
      series: this.dataList//[{"data":[272.56],"name":"Cambio de Producto"},{"data":[6.844],"name":"Falta de producto Semielaborado"},{"data":[21.04],"name":"Cambio de Consumible"},{"data":[2424.84],"name":"Produccion"}],//{"data":"27.135",0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"name":"Alimentacion en comedor"},{"data":[0,0,0,0,0,0,"41.275",0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"name":"Limpieza de linea"},{"data":[0,0,0,0,0,0,0,"1236.644",0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"name":"Falta de Asignacion de personal"},{"data":[0,0,0,0,0,0,0,0,"84.574",0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"name":"Arranque - Parada"},{"data":[0,0,0,0,0,0,0,0,0,"42.068",0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"name":"Cambio de formato"},{"data":[0,0,0,0,0,0,0,0,0,0,"7.655",0,0,0,0,0,0,0,0,0,0,0,0,0,0],"name":"Fallas de Codificación"},{"data":[0,0,0,0,0,0,0,0,0,0,0,"37.502",0,0,0,0,0,0,0,0,0,0,0,0,0],"name":"Paradas Operacionales Imprevistas"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,"2.632",0,0,0,0,0,0,0,0,0,0,0,0],"name":"Calibracion / Preparación de Linea"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,"0.358",0,0,0,0,0,0,0,0,0,0,0],"name":"Fallas por Servicios Eléctricos"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,"14.409",0,0,0,0,0,0,0,0,0,0],"name":"Parada por Mantenimiento planeado"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"0.498",0,0,0,0,0,0,0,0,0],"name":"Tuberías y Accesorios"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"1.170",0,0,0,0,0,0,0,0],"name":"Fallas Electrónicas"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"0.035",0,0,0,0,0,0,0],"name":"Sistemas de Instrumentación/Electrónica"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"0.406",0,0,0,0,0,0],"name":"Falta de Materiales de empaques"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"1.048",0,0,0,0,0],"name":"Parada por Capacitación / reunión"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"112.442",0,0,0,0],"name":"Servicios Internos/Externos"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"3.398",0,0,0],"name":"Falta de espacio para almacenar PP"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"0.127",0,0],"name":"Parada por Falta orden de producción"},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,"0.115",0],"name":"Parada por Pruebas"}],
      // [{
      //   name: 'Year 1800',
      //   data: [107, 31, 635, 203, 2]
      // }, {
      //   name: 'Year 1900',
      //   data: [133, 156, 947, 408, 6]
      // }, {
      //   name: 'Year 2000',
      //   data: [814, 841, 3714, 727, 31]
      // }, {
      //   name: 'Year 2016',
      //   data: [1216, 1001, 4436, 738, 40]
      // }]
    }
    let chart = new Chart(objSetting);
    this.chart = chart;
    chart.ref$.subscribe(console.log);
  }

  fun(arr) {
    let value = [];
    let maxValue = Number.MIN_VALUE;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][1] > maxValue) {
            maxValue = arr[i][1];
            value = arr[i];
        }
    }
    return value;
  }

  min(arr){
    let value = [];
    let minValue = 30000;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][0] < minValue) {
          minValue = arr[i][0];
            value = arr[i];
        }
    }
    return minValue != 30000 ? minValue : this.minAxis;
  }

  max(arr){
    let value = [];
    let maxValue = 0;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][0] > maxValue) {
            maxValue = arr[i][0];
            value = arr[i];
        }
    }
    return maxValue != 0 ? maxValue : this.maxAxis;
  }


  // addPoint() {
  //   if (this.chart) {
  //     this.chart.addPoint(Math.floor(Math.random() * 10));
  //   } else {
  //     alert('init chart, first!');
  //   }
  // }

  // addSerie() {
  //   /*this.chart = new Chart({
  //     chart: {
  //       type: 'line'
  //     },
  //     title: {
  //       text: 'Linechart'
  //     },
  //     credits: {
  //       enabled: false
  //     },
  //     series: [
  //       {
  //         name: 'Line 1',
  //         type:'line',
  //         data: [2, 2, 3]
  //       }
  //     ]
  //   });*/

  //   this.chart.addSeries({
  //     name: 'Line ' + Math.floor(Math.random() * 10),
  //     type:'pie',
  //     data: [
  //       Math.floor(Math.random() * 10),
  //       Math.floor(Math.random() * 10),
  //       Math.floor(Math.random() * 10),
  //       Math.floor(Math.random() * 10),
  //       Math.floor(Math.random() * 10),
  //       Math.floor(Math.random() * 10),
  //       Math.floor(Math.random() * 10),
  //       Math.floor(Math.random() * 10),
  //       Math.floor(Math.random() * 10)
  //     ]
  //   },true,true);
  // }

  // removePoint() {
  //   this.chart.removePoint(this.chart.ref.series[0].data.length - 1);
  // }

  // removeSerie() {
  //   this.chart.removeSeries(this.chart.ref.series.length - 1);
  // }

}
